// extracted by mini-css-extract-plugin
export var colorSquare = "_qx-0";
export var danger = "_qx-5";
export var lightPink = "_qx-8";
export var neutralBlue = "_qx-7";
export var neutralYellow = "_qx-6";
export var normal = "_qx-1";
export var primary = "_qx-2";
export var primaryLight = "_qx-3";
export var solidBlack = "_qx-g";
export var solidGreen = "_qx-b";
export var solidLightBlue = "_qx-d";
export var solidNavy = "_qx-c";
export var solidOrange = "_qx-f";
export var solidPink = "_qx-e";
export var solidRed = "_qx-9";
export var solidYellow = "_qx-a";
export var success = "_qx-4";